export const cityResourceUrl = 'cities';
